import React, { memo } from 'react';
import clsx from 'clsx';
import Typography from '@smart-tv/components/typography';
import useStream from '@smart-tv/components/player/_hooks/use-stream';
import { getPlaytime, getTimeDisplayValue } from './player-controls-scrubber-utils';
import testIds from '@smart-tv/e2e/shared/variables';

import styles from './player-controls-scrubber.module.scss';

interface Props {
  isPlacedLeft: boolean;
  progressSeconds: number;
  duration: number;
  startTime?: Date;
  endTime?: Date;
}

const ProgressbarDisplayTime = (props: Props) => {
  const { isPlacedLeft, progressSeconds, duration, startTime, endTime } = props;
  const { streamType } = useStream();

  const playtime = getPlaytime(progressSeconds, duration);

  if (!streamType) return null;

  const timeDisplayValue = getTimeDisplayValue(
    streamType === 'LIVE_STREAM',
    isPlacedLeft,
    playtime,
    startTime,
    endTime
  );

  const isTimeValueOverFourDigits = timeDisplayValue && timeDisplayValue.length > 5;

  const labelBase = styles['scrubber-time-label'];
  const startKey = isTimeValueOverFourDigits
    ? 'scrubber-time-label--vod-start-over-four-digits'
    : 'scrubber-time-label--vod-start';
  const endKey = isTimeValueOverFourDigits
    ? 'scrubber-time-label--vod-end-over-four-digits'
    : 'scrubber-time-label--vod-end';

  const testID = isPlacedLeft
    ? testIds.player.playerControls.leftTime
    : testIds.player.playerControls.rightTime;
  const alignment = isPlacedLeft ? 'left' : 'right';
  const styleKey = isPlacedLeft ? startKey : endKey;

  return (
    <>
      {timeDisplayValue && (
        <Typography
          component="div"
          variant="caption"
          textAlign={alignment}
          data-testid={testID}
          className={clsx(labelBase, styles[styleKey])}
        >
          {timeDisplayValue}
        </Typography>
      )}
    </>
  );
};

export default memo(ProgressbarDisplayTime);
